export const defaultHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

export const AUTHENTICATED = 'AUTHENTICATED';
export const SIGNED_OUT = 'SIGNED_OUT';
export const AUTH_EXPIRED = 'AUTH_EXPIRED';

export const AUTH_INIT = 'AUTH_INIT';
export const AUTH_INIT_SUCCESS = 'AUTH_INIT_SUCCESS';
export const AUTH_INIT_ERROR = 'AUTH_INIT_ERROR';

export const AUTH_SIGN_IN = 'AUTH_SIGN_IN';
export const AUTH_SIGN_IN_SUCCESS = 'AUTH_SIGN_IN_SUCCESS';
export const AUTH_SIGN_IN_ERROR = 'AUTH_SIGN_IN_ERROR';

export const AUTH_SIGN_OUT = 'AUTH_SIGN_OUT';
export const AUTH_SIGN_OUT_SUCCESS = 'AUTH_SIGN_OUT_SUCCESS';
export const AUTH_SIGN_OUT_ERROR = 'AUTH_SIGN_IN_ERROR';

export const AUTH_REGISTER = 'AUTH_REGISTER';
export const AUTH_REGISTER_SUCCESS = 'AUTH_REGISTER_SUCCESS';
export const AUTH_REGISTER_ERROR = 'AUTH_REGISTER_ERROR';

export const AUTH_PASSWORD_RESET_REQUEST = 'AUTH_PASSWORD_RESET_REQUEST';
export const AUTH_PASSWORD_RESET_REQUEST_SUCCESS = 'AUTH_PASSWORD_RESET_REQUEST_SUCCESS';
export const AUTH_PASSWORD_RESET_REQUEST_ERROR = 'AUTH_PASSWORD_RESET_REQUEST_ERROR';

export const AUTH_PASSWORD_RESET = 'AUTH_PASSWORD_RESET';
export const AUTH_PASSWORD_RESET_SUCCESS = 'AUTH_PASSWORD_RESET_SUCCESS';
export const AUTH_PASSWORD_RESET_ERROR = 'AUTH_PASSWORD_RESET_ERROR';

export const AUTH_CONFIRMATION = 'AUTH_CONFIRMATION';
export const AUTH_CONFIRMATION_SUCCESS = 'AUTH_CONFIRMATION_SUCCESS';
export const AUTH_CONFIRMATION_ERROR = 'AUTH_CONFIRMATION_ERROR';

export const AUTH_CONFIRMATION_LINK = 'AUTH_CONFIRMATION_LINK';
export const AUTH_CONFIRMATION_LINK_SUCCESS = 'AUTH_CONFIRMATION_LINK_SUCCESS';
export const AUTH_CONFIRMATION_LINK_ERROR = 'AUTH_CONFIRMATION_LINK_ERROR';

export const AUTH_PASSWORD_CHANGE = 'AUTH_PASSWORD_CHANGE';
export const AUTH_PASSWORD_CHANGE_SUCCESS = 'AUTH_PASSWORD_CHANGE_SUCCESS';
export const AUTH_PASSWORD_CHANGE_ERROR = 'AUTH_PASSWORD_CHANGE_ERROR';

export const AUTH_PROFILE_GET = 'AUTH_PROFILE_GET';
export const AUTH_PROFILE_GET_SUCCESS = 'AUTH_PROFILE_GET_SUCCESS';
export const AUTH_PROFILE_GET_ERROR = 'AUTH_PROFILE_GET_ERROR';

export const AUTH_PROFILE_CHANGE = 'AUTH_PROFILE_CHANGE';
export const AUTH_PROFILE_CHANGE_SUCCESS = 'AUTH_PROFILE_CHANGE_SUCCESS';
export const AUTH_PROFILE_CHANGE_ERROR = 'AUTH_PROFILE_CHANGE_ERROR';


export const NOTIFICATIONS_ADD = 'NOTIFICATIONS_ADD';
export const NOTIFICATIONS_SET = 'NOTIFICATIONS_SET';
export const NOTIFICATIONS_REMOVE = 'NOTIFICATIONS_REMOVE';
export const NOTIFICATIONS_CLEAR = 'NOTIFICATIONS_CLEAR';

export const GAME_DEFINITIONS_INVALIDATE = 'GAME_DEFINITIONS_INVALIDATE';
export const GAME_DEFINITIONS_LOAD = 'GAME_DEFINITIONS_LOAD';
export const GAME_DEFINITIONS_LOAD_SUCCESS = 'GAME_DEFINITIONS_LOAD_SUCCESS';
export const GAME_DEFINITIONS_LOAD_ERROR = 'GAME_DEFINITIONS_LOAD_ERROR';

//
// Student Groups
//

export const STUDENT_GROUP_CREATE = 'STUDENT_GROUP_CREATE';
export const STUDENT_GROUP_CREATE_SUCCESS = 'STUDENT_GROUP_CREATE_SUCCESS';
export const STUDENT_GROUP_CREATE_ERROR = 'STUDENT_GROUP_CREATE_ERROR';

// export const = '';

//
// Game Instance
//

export const GAME_INSTANCE_LOAD = 'GAME_INSTANCE_LOAD';
export const GAME_INSTANCE_LOAD_SUCCESS = 'GAME_INSTANCE_LOAD_SUCCESS';
export const GAME_INSTANCE_LOAD_ERROR = 'GAME_INSTANCE_LOAD_ERROR';

export const GAME_INSTANCE_CREATE = 'GAME_INSTANCE_CREATE';
export const GAME_INSTANCE_CREATE_SUCCESS = 'GAME_INSTANCE_CREATE_SUCCESS';
export const GAME_INSTANCE_CREATE_ERROR = 'GAME_INSTANCE_CREATE_ERROR';

export const GAME_INSTANCE_UPDATE = 'GAME_INSTANCE_UPDATE';
export const GAME_INSTANCE_UPDATE_SUCCESS = 'GAME_INSTANCE_UPDATE_SUCCESS';
export const GAME_INSTANCE_UPDATE_ERROR = 'GAME_INSTANCE_UPDATE_ERROR';

export const GAME_INSTANCE_INPUT = 'GAME_INSTANCE_INPUT';
export const GAME_INSTANCE_INPUT_SUCCESS = 'GAME_INSTANCE_INPUT_SUCCESS';
export const GAME_INSTANCE_INPUT_ERROR = 'GAME_INSTANCE_INPUT_ERROR';

export const GAME_INSTANCE_DISCARD = 'GAME_INSTANCE_DISCARD';
export const GAME_INSTANCE_DISCARD_SUCCESS = 'GAME_INSTANCE_DISCARD_SUCCESS';
export const GAME_INSTANCE_DISCARD_ERROR = 'GAME_INSTANCE_DISCARD_ERROR';

//
// Knowledge Questions
//

export const KNOWLEDGE_QUESTIONS_LOAD = 'KNOWLEDGE_QUESTIONS_LOAD';
export const KNOWLEDGE_QUESTIONS_LOAD_SUCCESS = 'KNOWLEDGE_QUESTIONS_LOAD_SUCCESS';
export const KNOWLEDGE_QUESTIONS_LOAD_ERROR = 'KNOWLEDGE_QUESTIONS_LOAD_ERROR';

// Bonus Tasks

export const BONUS_TASKS_LIST = 'BONUS_TASKS_LIST';
export const BONUS_TASKS_LIST_SUCCESS = 'BONUS_TASKS_LIST_SUCCESS';
export const BONUS_TASKS_LIST_ERROR = 'BONUS_TASKS_LIST_ERROR';

export const BONUS_TASKS_SUBMIT = 'BONUS_TASKS_SUBMIT';
export const BONUS_TASKS_SUBMIT_SUCCESS = 'BONUS_TASKS_SUBMIT_SUCCESS';
export const BONUS_TASKS_SUBMIT_ERROR = 'BONUS_TASKS_SUBMIT_ERROR';

// Creative Tasks

export const CREATIVE_TASKS_LIST = 'CREATIVE_TASKS_LIST';
export const CREATIVE_TASKS_LIST_SUCCESS = 'CREATIVE_TASKS_LIST_SUCCESS';
export const CREATIVE_TASKS_LIST_ERROR = 'CREATIVE_TASKS_LIST_ERROR';

export const CREATIVE_TASKS_SUBMIT = 'CREATIVE_TASKS_SUBMIT';
export const CREATIVE_TASKS_SUBMIT_SUCCESS = 'CREATIVE_TASKS_SUBMIT_SUCCESS';
export const CREATIVE_TASKS_SUBMIT_ERROR = 'CREATIVE_TASKS_SUBMIT_ERROR';

// Leaderboard

export const LEADERBOARD_LIST = 'LEADERBOARD_LIST';
export const LEADERBOARD_LIST_SUCCESS = 'LEADERBOARD_LIST_SUCCESS';
export const LEADERBOARD_LIST_ERROR = 'LEADERBOARD_LIST_ERROR';

// Theme

export const SET_THEME = 'SET_THEME';
